export default defineNuxtRouteMiddleware((to, from) => {
  const token = localStorage.getItem("token")
  const exempt_list = ["/login", "/request_password", "/set_password"]
  const exampt_path = exempt_list.some((path) => to.path.startsWith(path))
  const redirect = !token && !exampt_path
  if (redirect) {
    return navigateTo(`/login/?redirect_url=${to.fullPath.toString()}`)
  }
})
